import { localizeBrandText } from '@/utils/content'
import { navLabelKeys, resolveNavItemName } from '@/utils/navLabel'
import en from '@/i18n/en'
import zh from '@/i18n/zh'

export default {
  watch: {
    '$i18n.locale'() {
      if (typeof this.reloadCmsData === 'function') {
        this.reloadCmsData()
      }
    }
  },
  methods: {
    $navLabel(group, slug, fallback) {
      const keys = navLabelKeys(slug)
      for (let i = 0; i < keys.length; i++) {
        const key = group + '.' + keys[i]
        if (this.$te(key)) return this.$t(key)
      }
      return this.$cleanBrand(fallback || slug)
    },
    $navItemLabel(group, item) {
      if (!item) return ''
      if (group === 'product') {
        return this.$cleanBrand(item.name || item.productName || item.slug || '')
      }
      const messages = this.$i18n.locale === 'en' ? en : zh
      const label = resolveNavItemName(messages, group, item)
      return this.$cleanBrand(label || item.slug || item.categorySlug || item.itemSlug || '')
    },
    $newsTypeLabel(type) {
      const key = 'newsType.' + type
      return this.$te(key) ? this.$t(key) : (fallbackType(type))
    },
    $cleanBrand(text) {
      return localizeBrandText(text, this.$i18n.locale)
    }
  }
}

function fallbackType(type) {
  const map = { 0: 'Tech Wiki', 1: 'Company News', 2: 'Events', 3: 'Industry', 4: 'CSR' }
  return map[type] || 'News'
}
